import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTriangleWarn = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		fill: "none",
		children: [
			/* @__PURE__ */ _jsx("path", {
				stroke: "null",
				d: "m12,19.48687c-0.20674,0 -0.37435,-0.16759 -0.37435,-0.37435s0.16761,-0.37435 0.37435,-0.37435m0,0.7487c0.20676,0 0.37435,-0.16759 0.37435,-0.37435s-0.16759,-0.37435 -0.37435,-0.37435",
				id: "svg_2"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "null",
				strokeLinecap: "round",
				strokeMiterlimit: 10,
				d: "m12,15.74338l0,-7.48699",
				id: "svg_3"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "null",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "m13.61815,1.77765c-0.14854,-0.30246 -0.3789,-0.55724 -0.66496,-0.7354c-0.28594,-0.17817 -0.61621,-0.27261 -0.95318,-0.27261c-0.33701,0 -0.66724,0.09444 -0.95324,0.27261c-0.286,0.17817 -0.5164,0.43294 -0.66494,0.7354l-9.45656,19.26448c-0.11384,0.23168 -0.16677,0.48839 -0.15382,0.74606c0.01295,0.25767 0.09135,0.50792 0.22782,0.72678c0.13647,0.2191 0.32649,0.39963 0.55214,0.52481c0.22564,0.12518 0.47945,0.19083 0.73749,0.19059l19.42228,0c0.25803,0.00024 0.51175,-0.06541 0.73744,-0.19059c0.22569,-0.12518 0.41568,-0.30571 0.55212,-0.52481c0.13656,-0.21886 0.21491,-0.4691 0.22784,-0.72678c0.01294,-0.25767 -0.04001,-0.51439 -0.15381,-0.74606l-9.45661,-19.26448z",
				id: "svg_4"
			})
		]
	}));
});
export default SvgTriangleWarn;
